import React, { useEffect, useState } from 'react';
import { Box, Typography, Card, Button } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { BASEURL } from '../../Constants';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import Nav from './nav';

const PentestNotes = () => {
  const [notes, setNotes] = useState([]);
  const [summary, setSummary] = useState('');
  const { pentest_id } = useParams();
  const navigate = useNavigate();

  // Fetch pentest summary and notes from the API.
  const fetchNotes = () => {
    const token = sessionStorage.getItem('token');
    if (!token) {
      navigate('/');
      return;
    }

    fetch(`${BASEURL}/pentest/notes?pentest_id=${pentest_id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          if (data.message === 'Invalid token') {
            navigate('/');
          }
        } else {
          setNotes(data.notes);
          setSummary(data.summary);
        }
      })
      .catch((error) => console.error('Error fetching pentest notes:', error));
  };

  useEffect(() => {
    fetchNotes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // A component to render each note in its own card.
  const NoteCard = ({ noteObj }) => {
    const [expanded, setExpanded] = useState(false);

    // Function to get the first couple of sentences of the note.
    const getTruncatedText = (text) => {
      const sentences = text.split('. ');
      if (sentences.length <= 2) return text;
      return sentences.slice(0, 2).join('. ') + '.';
    };

    return (
      <Card sx={{ p: 2, mb: 2, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        <ReactMarkdown remarkPlugins={[remarkGfm]}>
          {expanded ? noteObj.note : getTruncatedText(noteObj.note)}
          </ReactMarkdown>
        </Typography>
        <Button size="small" onClick={() => setExpanded(!expanded)}>
          {expanded ? 'Read Less' : 'Read More'}
        </Button>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
          {new Date(noteObj.created_at).toLocaleString()}
        </Typography>
      </Card>
    );
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', p: 3, overflowX: 'auto' }}>
      {/* Navigation */}
      <Nav />

      {/* Pentest Summary Card */}
      <Card sx={{ p: 3, borderRadius: 2, boxShadow: 3, mb: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
          Pentest Summary
        </Typography>
        <Typography variant="body2" color="text.secondary" component="div">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {summary || '*No summary provided.*'}
          </ReactMarkdown>
        </Typography>
      </Card>

      {/* Pentest Notes */}
      <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
        Pentest Notes
      </Typography>
      {notes.length > 0 ? (
        notes.map((noteObj) => (
          <NoteCard key={noteObj.id} noteObj={noteObj} />
        ))
      ) : (
        <Typography variant="body2" color="text.secondary">
          No pentest notes available.
        </Typography>
      )}
    </Box>
  );
};

export default PentestNotes;
